import * as React from 'react';

const InventoryTwoSvg = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={15} height={16} fill='none' {...props}>
    <path
      fill='#919191'
      d='M12.484 11.03H8.351V6.71a3.333 3.333 0 1 0-1.976 0v4.32H4.602v-.533a.588.588 0 0 0-.58-.588h-.604a.588.588 0 0 0-.58.588v.533h-.353a1.843 1.843 0 0 0-1.843 1.843v1.098a1.843 1.843 0 0 0 1.843 1.835h9.999a1.843 1.843 0 0 0 1.843-1.835v-1.098a1.842 1.842 0 0 0-1.843-1.843ZM5.959 2.521a.714.714 0 1 1 1.427 0 .714.714 0 0 1-1.427 0Z'
    />
  </svg>
);
export default InventoryTwoSvg;
